import { set, lensPath } from 'ramda';
import { initialState } from './selectors';
import { FILTER_SET, FILTER_CLEAR, FILTER_MIDDLEWARE_SET } from './actions';

export default (state = initialState, { type, payload: { name, middleware, value } = {} }) => {
  if (!name) {
    return state;
  }
  switch (type) {
    case FILTER_SET:
      return {
        ...state,
        [name]: value,
      };
    case FILTER_CLEAR: // eslint-disable-line no-case-declarations
      const { [name]: dummy, ...rest } = state;
      return rest;
    case FILTER_MIDDLEWARE_SET:
      return set(lensPath([name, middleware]), value, state);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/filter/reducer.js